import {useContext} from "react";
import {StateContext} from "../Contexts";
import {getCurrentPlan} from "../Billwerk/SubscriptionJS";
import jahrestarif_siegel from "../../../img/jahrestarif-siegel.svg";
import Card from "@erecht24/frontend-kit/theme/components/cards/Card";
import CardBody from "@erecht24/frontend-kit/theme/components/cards/CardBody";

export default function () {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    let plan = getCurrentPlan(state);

    if (!plan?.custom_fields?.ProductBenefits) {
        return null;
    }

    return <Card className="tile active">
        <CardBody className="pr-[1.5rem] md:pr-[150px]">
            <div className="plan-details--list annual-plan" dangerouslySetInnerHTML={{__html: plan?.custom_fields?.ProductBenefits}}>
            </div>
            <img className="absolute hidden md:inline top-0 right-10" src={jahrestarif_siegel} alt="25 Jahre Expertise"/>
        </CardBody>
    </Card>
}
